import { Link } from 'react-router-dom';
import { useCopy, supportLink } from '@/lib/settings';
import { ActsLogo } from '@/components/ui/ActsLogo';
import { PoweredByCcms } from '@/components/ui/PoweredByCcms';

/**
 * Footer. `variant="public"` is the slim footer at the end of signed-out pages on every screen
 * size; `variant="app"` only shows on desktop (signed-in phones have no footer: the same links
 * live in Account → About Carpool). Never rendered in step flows or on ride day.
 */
export function SiteFooter({ variant }: { variant: 'public' | 'app' }) {
  const { settings } = useCopy();
  const support = supportLink(settings);
  const year = new Date().getFullYear();
  const links = [
    { to: '/privacy', label: 'Privacy notice' },
    { to: '/terms', label: 'Terms' },
  ];
  return (
    <footer className={`rides-footer${variant === 'app' ? ' is-app' : ''}`}>
      <div className="rides-footer-inner">
        <div className="brand">
          <ActsLogo height={24} />
          <span>© {year} Acts Church</span>
        </div>
        <nav className="rides-footer-links" aria-label="Footer">
          {links.map((l, i) => (
            <span key={l.to} style={{ display: 'inline-flex', alignItems: 'center' }}>
              {i > 0 && <span className="dot" aria-hidden="true">·</span>}
              <Link to={l.to}>{l.label}</Link>
            </span>
          ))}
          {support && (
            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
              <span className="dot" aria-hidden="true">·</span>
              <a href={support.href}>Help</a>
            </span>
          )}
        </nav>
        <PoweredByCcms />
      </div>
    </footer>
  );
}
